import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const NEWFOUNDLAND_TZ = "America/St_Johns";

/**
 * Formats a date (in UTC) into Newfoundland time with specified format.
 *
 * @param {Date | string} date - UTC date input
 * @param {string} formatStr - Output format (default: 'MMM D, YYYY')
 * @returns {string} - Formatted date string in Newfoundland time
 */
export const formatDateInNewfoundland = (date, formatStr = "MMM D, YYYY") => {
  if (!date) return "";
  return dayjs(date).tz(NEWFOUNDLAND_TZ).format(formatStr);
};
